export default function base64Decode(value: string): string {
  return typeof window !== "undefined" ? window.atob(value) : Buffer.from(value, "base64").toString();
}
